module.exports = __webpack_public_path__ + "static/media/Memb-I-00131_0038.83da0cf8.jpg";